import PropTypes from 'prop-types'
import React from 'react'
import { FormattedMessage } from 'react-intl'
import { Link } from 'react-router-dom'
import { Modal } from 'components/Modal'
import {
  FormGroup,
  ControlLabel
} from 'react-bootstrap'
import {
  LeftSidebarView,
  ViewBody,
} from 'components/Sidebar'
import withLeftSidebar from 'components/Sidebar/withLeftSidebar'
import Loader from 'components/Loader'
import KanBoIcon from 'components/KanBoIcon'
import {
  ListItem
} from 'components/List'
import AddDocumentSource from './components/AddDocumentSource'
import EditDocumentSource from './components/EditDocumentSource'
import InfiniteScroll from 'components/InfiniteScroll'
import { KanBoLink } from 'components/Link'

export class DocumentSources extends React.Component {
  static propTypes = {
    leftSidebar: PropTypes.object.isRequired,

    areDocumentSourcesLoading: PropTypes.bool.isRequired,
    areDocumentSourcesLoaded: PropTypes.bool.isRequired,
    documentSources: PropTypes.array.isRequired,

    fetchDocumentSources: PropTypes.func.isRequired,
    fetchDocumentSourceDetails: PropTypes.func.isRequired,
    fetchAllDocumentSourcesDetails: PropTypes.func.isRequired,
    requestRepairDocumentSource: PropTypes.func.isRequired,
    requestRepairAllDocumentSources: PropTypes.func.isRequired,
    requestRemoveDocumentSource: PropTypes.func.isRequired
  }

  state = {
    showModal: false,
    checkingPermissions: false,
    repairingAll: false
  }

  openModal = (index) => {
    this.setState({
      showModal: index
    })
  }

  closeModal = () => {
    this.setState({
      showModal: false
    })
  }

  handleAddDocumentSourceClick = () => {
    this.props.leftSidebar.push(AddDocumentSource)
  }

  handleCheckPermissionsClick = () => {
    const { fetchAllDocumentSourcesDetails } = this.props

    this.setState({
      checkingPermissions: true
    })

    fetchAllDocumentSourcesDetails({
      onEnd: this.handleCheckPermissionsEnd
    })
  }

  handleCheckPermissionsEnd = () => {
    this.setState({
      checkingPermissions: false
    })
  }

  handleRepairAllClick = () => {
    const { requestRepairAllDocumentSources } = this.props

    this.setState({
      repairingAll: true
    })

    requestRepairAllDocumentSources({
      onEnd: this.handleRepairAllEnd
    })
  }

  handleRepairAllEnd = () => {
    this.setState({
      repairingAll: false
    })
  }

  loadDocumentSources = () => {
    const {
      fetchDocumentSources
    } = this.props

    fetchDocumentSources()
  }

  render () {
    const {
      leftSidebar,

      areDocumentSourcesLoading,
      areDocumentSourcesLoaded,
      documentSources,

      fetchDocumentSourceDetails,
      requestRepairDocumentSource,
      requestRemoveDocumentSource
    } = this.props
    const {
      showModal,
      checkingPermissions,
      repairingAll
    } = this.state

    const selectedDocumentSource =
      showModal !== false
        ? documentSources[showModal]
        : null

    return (
      <LeftSidebarView
        title={<FormattedMessage id='DOCUMENTS_SOURCES_HEADER' />}
        buttons={[{
          icon: <KanBoIcon fixedWidth name='kanbo-16-plus' />,
          title: <FormattedMessage id='ADD' />,
          onClick: this.handleAddDocumentSourceClick
        }]}
        menu={[{
          icon: checkingPermissions ? <KanBoIcon spin name='kanbo-16-loading' /> : <KanBoIcon fixedWidth name='kanbo-16-tasks' />,
          title: <FormattedMessage id='DOCUMENTS_SOURCES_CHECK_PERMISSIONS' />,
          disabled: checkingPermissions || repairingAll,
          onClick: this.handleCheckPermissionsClick
        }, {
          icon: repairingAll ? <KanBoIcon spin name='kanbo-16-loading' /> : <KanBoIcon fixedWidth name='kanbo-16-repair' />,
          title: <FormattedMessage id='DOCUMENTS_SOURCES_REPAIR_ALL' />,
          disabled: checkingPermissions || repairingAll,
          onClick: this.handleRepairAllClick
        }]}
      >
        <InfiniteScroll
          isLoading={areDocumentSourcesLoading}
          isLoaded={areDocumentSourcesLoaded}
          onLoadMore={this.loadDocumentSources}
        >
          <ul className='list-group'>
            {documentSources.map((documentSource, index) => {
              const onClick = () => {
                leftSidebar.push(() => <EditDocumentSource id={documentSource.id} />)
              }

              const onDetailsClick = () => {
                fetchDocumentSourceDetails({ id: documentSource.id })

                this.openModal(index)
              }

              const onRepairClick = () =>
                requestRepairDocumentSource({ id: documentSource.id })

              const onRemoveClick = () =>
                requestRemoveDocumentSource({ id: documentSource.id })

              return (
                <ListItem
                  key={documentSource.id}
                  className={
                    typeof documentSource.isReadable !== 'undefined'
                      ? (documentSource.isReadable ? 'list-group-item-success' : 'list-group-item-danger')
                      : null
                  }
                  icon={
                    !documentSource.isBusy
                      ? <KanBoIcon name='kanbo-16-document-sources' />
                      : <KanBoIcon spin name='kanbo-16-loading' />
                  }
                  subtitle={documentSource.url}
                  menu={[
                    {
                      icon: <KanBoIcon fixedWidth name='kanbo-16-document-references' />,
                      title: <FormattedMessage id='DOCUMENTS_SOURCE_DETAILS' />,
                      onClick: onDetailsClick
                    },
                    {
                      icon: <KanBoIcon fixedWidth name='kanbo-16-repair' />,
                      title: <FormattedMessage id='DOCUMENTS_SOURCES_REPAIR' />,
                      disabled: documentSource.isBusy,
                      onClick: onRepairClick
                    },
                    {
                      icon: <KanBoIcon fixedWidth name='kanbo-16-remove' />,
                      title: <FormattedMessage id='REMOVE' />,
                      onClick: onRemoveClick
                    }
                  ]}
                  onClick={onClick}
                >
                  {documentSource.name}
                </ListItem>
              )
            })}
          </ul>
        </InfiniteScroll>
        {(selectedDocumentSource && showModal !== false) &&
          <Modal onClose={this.closeModal}>
            <LeftSidebarView
              title={selectedDocumentSource.name}
            >
              <ViewBody>
                <FormGroup>
                  <ControlLabel>
                    <FormattedMessage id='DOCUMENTS_SOURCES_TITLE_LIB_URL' />
                  </ControlLabel>
                  <div>
                    <div>
                      <KanBoLink href={selectedDocumentSource.url}>{selectedDocumentSource.url}</KanBoLink>
                    </div>
                  </div>
                </FormGroup>
                {!selectedDocumentSource.isLoaded &&
                  <Loader center />
                }
                {selectedDocumentSource.isLoaded &&
                  <FormGroup>
                    <ControlLabel>
                      <FormattedMessage
                        id='DOCUMENTS_SOURCE_BOARDS_USING'
                        values={{ count: selectedDocumentSource.boards.length }}
                      />
                    </ControlLabel>
                    {selectedDocumentSource.boards.map(board =>
                      <div key={board.id}>
                        {board.accessDenied ? (
                          <i>
                            <FormattedMessage
                              id='BOARD_ACCESS_DENIED'
                            />
                          </i>
                        ) : (
                          <Link
                            to={'/board/' + board.id}
                            target='_blank'
                          >
                            {board.name}
                          </Link>
                        )}
                      </div>
                    )}
                  </FormGroup>
                }
              </ViewBody>
            </LeftSidebarView>
          </Modal>
        }
      </LeftSidebarView>
    )
  }
}

export default withLeftSidebar(DocumentSources)
